import cloneDeep from 'lodash/cloneDeep';

import { mapCol, mapCondition, mapRow } from '@webapp/common/lib/map';
import { initialQuestion as _initialQuestion } from '@webapp/common/resources/entities/question';
import type { QuestionType } from '@webapp/common/resources/survey';

import type { LogicConditionResponse } from './map-logic';
import type { LogicPageQuestion } from './question';
import { initialQuestion } from './question';

export interface QuestionResponse {
    ID: number;
    answers: Array<any>;
    groups: Array<any>;
    logics: Array<LogicConditionResponse>;
    PAGE: number;
    parameters: {
        params: string; // JSON
    };
    QUESTION: string; // title
    QUESTION_TYPE_ID: QuestionType;
    SERIAL: number;
    ORDER: number;
    PINNED: number;
    MAXDIFF_BLOCK_COUNT?: number;
}

export const mapQuestion = (data: QuestionResponse): LogicPageQuestion => {
    const {
        answers,
        groups,
        ID,
        logics,
        PAGE,
        parameters: { params },
        QUESTION,
        QUESTION_TYPE_ID,
        MAXDIFF_BLOCK_COUNT,
        SERIAL,
        ORDER,
        PINNED,
    } = data;
    const question: LogicPageQuestion = {
        ...cloneDeep(initialQuestion),
        expand: true,
        id: ID,
        name: QUESTION === null ? '' : QUESTION,
        type: QUESTION_TYPE_ID,
        pageId: PAGE,
        conditions: logics.map((logic: any) => mapCondition(logic, data)),
        rows: answers.map(mapRow),
        cols: groups.map(mapCol),
        order: ORDER,
        serial: SERIAL,
        pinned: PINNED === 1,
        maxDiffBlockCount: MAXDIFF_BLOCK_COUNT,
    };

    if (params) {
        question.params = Object.assign(cloneDeep(_initialQuestion.params), {
            scaleType: 'custom',
            ...JSON.parse(params),
        });
    }

    return question;
};
